export const getClientProps = (state) => state.get('client');
export const getClientEmail = (state) => getClientProps(state).get('email');
